<ion-content>
  <div class="px-4 py-2 padding-bottom-configuration">
    <app-header-configuration
      [title]="'P00061.installation.pac' | translate"
      [description]="''"
    >
    </app-header-configuration>

    <app-information-title
      [title]="'P00061.installation.position' | translate"
    ></app-information-title>

    <app-larged-link
      [name]="'P00061.installation.position.smalltitle' | translate"
      [textBeforeArrow]="
        P00061PositionType[positionRaccordement].label | translate
      "
      (onPress)="openPositionModal()"
    >
    </app-larged-link>

    <app-label-description
      [description]="'P00061.installation.position.description' | translate"
    ></app-label-description>
  </div>
</ion-content>

<div class="position-absolute start-0 end-0 bottom-0 bg-white px-4 py-2">
  <div class="row">
    <div class="col-6 text-start">
      <ion-button
        color="medium"
        expand="block"
        fill="outline"
        class="mb-3"
        (click)="this.prev()"
      >
        {{ 'generic.retour' | translate }}
      </ion-button>
    </div>
    <div class="col-6 text-end">
      <ion-button color="primary" expand="block" (click)="onSubmit()">
        {{ 'generic.next' | translate }}
      </ion-button>
    </div>
  </div>
</div>
